import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useTokenAuth from "./useTokenAuth";
import { logout } from "reducers/userValuesSlice";

const RequireAuth = ({ route, children }) => {
    const auth = useSelector((state) => state.userValues);
    const dispatch = useDispatch();
    useTokenAuth();

    const roleId = useSelector((state) => state.userValues.user?.role?.id);

    useEffect(() => {
        if (!auth.user || !roleId) {
            dispatch(logout());
        }
    }, [auth.user, dispatch, roleId]);

    if (!auth.user || !roleId) {
        return <Navigate to="/login" />;
    }

    const hasPermissions = route?.permissions
        ? route.permissions.includes(roleId)
        : true;

    if (!auth.user) {
        return <Navigate to="/login" />;
    }

    if (!hasPermissions) {
        return <Navigate to="/unauthorized" />;
    }

    return children;
};

export default RequireAuth;
